import React, { useState, useContext, useEffect } from 'react';
import { Switch, Route, useParams, useHistory, useRouteMatch, Redirect } from 'react-router-dom';
import { getSurgeon } from '../../../api/surgeons';
import { findAndSetMentor } from '../../../helpers/find_mentor_helper';
import {
  createSurgeonReferredMentorMatch,
  getSurgeonReferredMentorMatch,
  updateSurgeonReferredMentorMatch,
} from '../../../api/surgeon_referred_mentor_matches';

import Context from '../../../utils/context';
import styles from './index.module.css';
import SignUp from '../../sign_up';
import PatientGender from '../patient_partner/patient_gender';
import Age from '../age/age';
import OptionsAndOther from '../choose_an_option';
import InsuranceSelection from '../../surgeon/referred_mentor_match/pre_conversation_questionnaire/insurance_selection/index.jsx';
import LoadingScreen from '../../loading_screen';
import MentorMatch from '../../surgeon/referred_mentor_match/pre_conversation_questionnaire/mentor_match';
import MentorConversationTopics from '../../surgeon/referred_mentor_match/pre_conversation_questionnaire/myelofibrosis/mentor_conversation_topics';

export default function Reactiv8Questionnaire({
  australiaPhone,
  countryRestriction,
  origin,
  captureLocation,
  locationPlaceholder,
  surgeonId,
}) {
  const { id } = useParams();
  const context = useContext(Context);
  const history = useHistory();
  const [surgeon, setSurgeon] = useState(null);
  const [currentGender, setCurrentGender] = useState('');
  const [currentPatientType, setCurrentPatientType] = useState('');
  const [currentMilitary, setCurrentMilitary] = useState('');
  const [currentInsurance, setCurrentInsurance] = useState('');
  const [currentHasHadTreatment, setCurrentHasHadTreatment] = useState('');
  const [currentHasSpokenWithDoctorAboutTreatment, setCurrentHasSpokenWithDoctorAboutTreatment] = useState('');
  const [currentScheduledTreatment, setCurrentScheduledTreatment] = useState('');
  const [mentorFound, setMentorFound] = useState(false);
  const [currentBirthday, setCurrentBirthday] = useState(
    context.auth.isLoggedIn() ? context.auth.getCurrentUser().date_of_birth : null
  );
  const [mentorConversationTopics, setMentorConversationTopics] = useState(() => {
    const saved = sessionStorage.getItem('mentorConversationTopics');
    return saved ? JSON.parse(saved) : [];
  });
  const [surgeonReferredMentorMatch, setSurgeonReferredMentorMatch] = useState(() => {
    const saved = sessionStorage.getItem('surgeonReferredMentorMatch');
    return saved ? JSON.parse(saved) : '';
  });
  const [patientPartner, setPatientPartner] = useState(() => {
    const saved = sessionStorage.getItem('patientPartner');
    return saved ? JSON.parse(saved) : '';
  });

  const baseSteps = [
    'gender',
    'age',
    'has-had-treatment',
    'has-spoken-with-doctor-about-treatment',
    'scheduled-treatment',
  ];

  const usSteps = ['military', 'insurance', 'conversation-topics', 'loading-patient-partner', 'patient-partner'];
  const ausSteps = ['insurance', 'conversation-topics', 'loading-patient-partner', 'patient-partner'];

  const steps =
    surgeonReferredMentorMatch && surgeonReferredMentorMatch.surgeon.slug === 'reactiv8'
      ? [...baseSteps, ...usSteps]
      : [...baseSteps, ...ausSteps];

  let { path } = useRouteMatch();

  path = path.replace(`:id`, id);

  let nextStep = steps[steps.findIndex((r) => window.location.pathname.includes(r)) + 1];
  let previousStep = steps[steps.findIndex((r) => window.location.pathname.includes(r)) - 1];

  if (!nextStep) {
    nextStep = 'patient-partner';
  }

  if (!previousStep) {
    previousStep = 'gender';
  }

  const insuranceChoices =
    surgeonReferredMentorMatch && surgeonReferredMentorMatch.surgeon.slug === 'reactiv8'
      ? ['Commercial Insurance', 'Medicare', 'Medicaid', 'VHA', 'Uninsured']
      : ['Private', 'DVA - White', 'DVA - Gold', "Workers' Compensation", 'Not covered'];

  const topics = [
    `Pros and cons of the therapy`,
    `What the unit and therapy feel like`,
    'Tips for preparing and recovering',
    'Previous symptoms and result details',
  ];

  const conversationTopicsOptions =
    surgeonReferredMentorMatch && surgeonReferredMentorMatch.surgeon.slug === 'reactiv8'
      ? [...topics, 'Insurance coverage information']
      : [...topics, 'Insurance approval process and helpful tips'];

  const scrollToTopOfPage = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const createAndRedirect = () => {
    createSurgeonReferredMentorMatch(
      {
        surgeon_id: surgeon.id,
        surgery: 'Mechanical Chronic Low Back Pain',
      },
      (match) => {
        history.push(`/member/mentor-matches/${match.uuid}/${surgeon.slug}/gender`);
        setTimeout(() => {
          scrollToTopOfPage();
        }, 0);
      }
    );
  };

  const update = (params) => {
    getSurgeonReferredMentorMatch(id, (data) => {
      updateSurgeonReferredMentorMatch(data.uuid, params, (data) => {
        setSurgeonReferredMentorMatch(data);
        sessionStorage.setItem('surgeonReferredMentorMatch', JSON.stringify(data));
      });
    });
  };

  useEffect(() => {
    if (id) {
      getSurgeonReferredMentorMatch(id, (data) => {
        setSurgeonReferredMentorMatch(data);
        sessionStorage.setItem('surgeonReferredMentorMatch', JSON.stringify(data));
        getSurgeon(data.surgeon.id, (surgeon) => {
          setSurgeon(surgeon);
        });
      });
    }

    if (surgeonId) {
      getSurgeon(surgeonId, (surgeon) => {
        setSurgeon(surgeon);
      });
    }
  }, []);

  useEffect(() => {
    if (mentorFound && patientPartner) {
      history.push(`${path}/patient-partner`);
    }
  }, [mentorFound, patientPartner]);

  return (
    <div
      className={styles.questionnaire_ottr}
      id='questionnaire'
      style={{ backgroundColor: '#f5f7f9', maxWidth: '100%' }}
    >
      <div className={`${styles.questionnaire_content}`}>
        <div className={`${styles.cont_row}`}>
          <div
            className={`col-md-8`}
            style={{ paddingLeft: '15px', paddingRight: '15px', flex: '0 0 100%', maxWidth: '100%' }}
          >
            {/* 1  */}
            <Switch>
              <Route exact path={`${path}`}>
                {context.auth.isLoggedIn() ? (
                  <Redirect to={`${path}/${steps[0]}`} />
                ) : (
                  <SignUp
                    onSuccess={createAndRedirect}
                    params={{
                      keap_force_sync: true,
                      origin: origin,
                      procedure: 'ReActiv8',
                      surgery: 'Mechanical Chronic Low Back Pain',
                    }}
                    headline={
                      <div style={{ color: '#129A76', fontWeight: '700', fontSize: '25px' }}>
                        Get matched with your mentor!
                      </div>
                    }
                    para={`Create your account and get your mentor match.`}
                    alignLeft
                    light={false}
                    captureFirstLastName
                    embedded
                    captureLocation={captureLocation}
                    locationPlaceholder={locationPlaceholder}
                    australiaPhone={australiaPhone}
                    countryRestriction={countryRestriction}
                    useFacebookConversionApi
                  />
                )}
              </Route>

              {/* 2 */}
              <Switch>
                <Route exact path={`${path}/gender`}>
                  <PatientGender
                    answers={{ gender: currentGender }}
                    title={'What is your gender?'}
                    para={'When possible, we try to match by gender, as it can support stronger connections.'}
                    onSubmit={(answers) => {
                      setCurrentGender(answers.gender);
                      context.auth.userUpdate({ gender: answers.gender }, () => history.push(`${path}/${nextStep}`));
                    }}
                    onBack={() => history.push(`${path}/${previousStep}`)}
                    gtm={'Gender'}
                  />
                </Route>
              </Switch>
            </Switch>

            {/* 3 */}
            <Switch>
              <Route exact path={`${path}/age`}>
                <Age
                  title={'What is your birthday?'}
                  para={`We'll match you with a mentor in your age group.`}
                  answers={{ date_of_birth: currentBirthday }}
                  onSubmit={(answers) => {
                    setCurrentBirthday(answers.date_of_birth);
                    context.auth.userUpdate({ date_of_birth: answers.date_of_birth }, () =>
                      history.push(`${path}/${nextStep}`)
                    );
                  }}
                  onBack={() => history.push(`${path}/${previousStep}`)}
                  gtm={'Age'}
                  cta={'Next'}
                />
              </Route>
            </Switch>

            {/* 4 */}
            <Switch>
              <Route exact path={`${path}/has-had-treatment`}>
                <OptionsAndOther
                  title={'Do you already have a ReActiv8 implant?'}
                  para={'This helps us understand where you are in your treatment journey.'}
                  answers={{ has_had_treatment: currentHasHadTreatment }}
                  onSubmit={(answers) => {
                    setCurrentHasHadTreatment(answers.has_had_treatment);
                    update({ data: { has_had_treatment: answers.has_had_treatment } });
                    if (answers.has_had_treatment === 'Yes' && surgeon.slug === 'reactiv8') {
                      // 7 US
                      history.push(`${path}/military`);
                    } else if (answers.has_had_treatment === 'Yes' && surgeon.slug === 'reactiv8-australia') {
                      // 7 AUS
                      history.push(`${path}/insurance`);
                    } else {
                      // 5
                      history.push(`${path}/${nextStep}`);
                    }
                  }}
                  choices={['Yes', 'No']}
                  showOther={false}
                  keyForAnswer={'has_had_treatment'}
                  onBack={() => history.push(`${path}/${previousStep}`)}
                  gtm={'Has Had Treatment'}
                  cta={'Next'}
                  selectOne
                />
              </Route>
            </Switch>

            {/* 5 US */}
            {/* 5 AUS */}
            <Switch>
              <Route exact path={`${path}/has-spoken-with-doctor-about-treatment`}>
                <OptionsAndOther
                  title={'Have you spoken with your doctor about ReActiv8 therapy?'}
                  para={'Knowing this helps us understand where you are in your treatment journey.'}
                  answers={{ has_spoken_with_doctor_about_treatment: currentHasSpokenWithDoctorAboutTreatment }}
                  onSubmit={(answers) => {
                    setCurrentHasSpokenWithDoctorAboutTreatment(answers.has_spoken_with_doctor_about_treatment);
                    update({
                      data: { has_spoken_with_doctor_about_treatment: answers.has_spoken_with_doctor_about_treatment },
                    });
                    if (answers.has_spoken_with_doctor_about_treatment === 'Yes' && surgeon.slug === 'reactiv8') {
                      // 6 US
                      history.push(`${path}/scheduled-treatment`);
                    } else if (answers.has_spoken_with_doctor_about_treatment === 'No' && surgeon.slug === 'reactiv8') {
                      // 7 US
                      history.push(`${path}/military`);
                    } else if (
                      answers.has_spoken_with_doctor_about_treatment === 'Yes' &&
                      surgeon.slug === 'reactiv8-australia'
                    ) {
                      // 6 AUS
                      history.push(`${path}/scheduled-treatment`);
                    } else if (
                      answers.has_spoken_with_doctor_about_treatment === 'No' &&
                      surgeon.slug === 'reactiv8-australia'
                    ) {
                      // 7 AUS
                      history.push(`${path}/insurance`);
                    }
                  }}
                  choices={['Yes', 'No']}
                  showOther={false}
                  keyForAnswer={'has_spoken_with_doctor_about_treatment'}
                  onBack={() => history.push(`${path}/${previousStep}`)}
                  gtm={'Has Spoken With Doctor About Treatment'}
                  cta={'Next'}
                  selectOne
                />
              </Route>
            </Switch>

            {/* 6 US */}
            {/* 6 AUS */}
            <Switch>
              <Route exact path={`${path}/scheduled-treatment`}>
                <OptionsAndOther
                  title={'Do you have ReActiv8 implant surgery scheduled?'}
                  para={"We'll tailor your match based on whether you’re preparing for surgery."}
                  answers={{ scheduled_treatment: currentScheduledTreatment }}
                  onSubmit={(answers) => {
                    setCurrentScheduledTreatment(answers.scheduled_treatment);
                    update({
                      data: { scheduled_treatment: answers.scheduled_treatment },
                    });
                    history.push(`${path}/${nextStep}`);
                  }}
                  choices={['Yes', 'No']}
                  showOther={false}
                  keyForAnswer={'scheduled_treatment'}
                  onBack={() => history.push(`${path}/${previousStep}`)}
                  gtm={'Scheduled Treatment'}
                  cta='Next'
                  selectOne
                />
              </Route>
            </Switch>

            {/* 7 US */}
            <Switch>
              <Route exact path={`${path}/military`}>
                <OptionsAndOther
                  answers={{ military: currentMilitary }}
                  keyForAnswer={'military'}
                  onSubmit={(answers) => {
                    update({ military: answers['military'] });
                    setCurrentMilitary(answers['military']);
                    history.push(`${path}/${nextStep}`);
                  }}
                  onBack={() => {
                    if (
                      currentHasSpokenWithDoctorAboutTreatment === 'Yes' ||
                      currentHasSpokenWithDoctorAboutTreatment === 'No'
                    ) {
                      history.push(`${path}/has-spoken-with-doctor-about-treatment`);
                    } else if (currentHasHadTreatment === 'Yes') {
                      history.push(`${path}/has-had-treatment`);
                    } else {
                      history.push(`${path}/${previousStep}`);
                    }
                  }}
                  choices={['Currently Active', 'Veteran', 'N/A']}
                  title={`Have you served in the military?`}
                  para={``}
                  showOther={false}
                  ctaTxt='Next'
                  optional
                  selectOne
                />
              </Route>
            </Switch>

            {/* 8 US */}
            {/* 7 AUS */}
            <Switch>
              <Route exact path={`${path}/insurance`}>
                <InsuranceSelection
                  value={currentInsurance}
                  choices={insuranceChoices}
                  onSubmit={(answers) => {
                    update({ insurance_selection: answers['insuranceSelection'] });
                    setCurrentInsurance(answers['insuranceSelection']);
                    history.push(`${path}/${nextStep}`);
                  }}
                  onBack={() => {
                    if (currentHasSpokenWithDoctorAboutTreatment === 'No' && surgeon.slug === 'reactiv8-australia') {
                      history.push(`${path}/has-spoken-with-doctor-about-treatment`);
                    } else if (currentHasHadTreatment === 'Yes' && surgeon.slug === 'reactiv8-australia') {
                      history.push(`${path}/has-had-treatment`);
                    } else {
                      history.push(`${path}/${previousStep}`);
                    }
                  }}
                />
              </Route>
            </Switch>

            {/* 9 US */}
            {/* 8 AUS */}
            <Switch>
              <Route exact path={`${path}/conversation-topics`}>
                <MentorConversationTopics
                  answers={mentorConversationTopics}
                  showOther={true}
                  title={`What would you like to talk to your mentor about? (Select all that apply.)`}
                  para={`We'll let your mentor know some topics you'd like to talk about.`}
                  choices={conversationTopicsOptions}
                  onSubmit={(answers) => {
                    update({ conversation_topics: answers['mentorConversationTopics'] });
                    setMentorConversationTopics(answers['mentorConversationTopics']);
                    sessionStorage.setItem(
                      'mentorConversationTopics',
                      JSON.stringify(answers['mentorConversationTopics'])
                    );
                    history.push(`${path}/${nextStep}`);

                    findAndSetMentor(
                      {
                        onSetPatientPartner: setPatientPartner,
                        onMentorFound: setMentorFound,
                      },
                      context
                    );
                  }}
                  onBack={() => history.push(`${path}/${previousStep}`)}
                />
              </Route>
            </Switch>

            <Switch>
              <Route exact path={`${path}/loading-patient-partner`}>
                <LoadingScreen
                  title={'Finding your mentor...'}
                  content={
                    'Get ready to meet a real patient who will answer your questions and support you through your journey!'
                  }
                />
              </Route>
            </Switch>

            <Switch>
              <Route exact path={`${path}/patient-partner`}>
                <MentorMatch
                  patientPartner={patientPartner}
                  id={id}
                  whatsNextMessage={(p) => {
                    return `Send your first message to ${p.name} and get answers to questions about the procedure, recovery, and their experience.`;
                  }}
                  callback={(conversation) => {
                    updateSurgeonReferredMentorMatch(
                      surgeonReferredMentorMatch.uuid,
                      { conversation_id: conversation.id },
                      () => {
                        let firstMessage = '';
                        if (mentorConversationTopics && mentorConversationTopics.length > 0) {
                          if (mentorConversationTopics.length === 1 || mentorConversationTopics.length === 2) {
                            firstMessage =
                              'Hi ' +
                              patientPartner.name +
                              ', I would like to chat about ' +
                              (mentorConversationTopics || []).join(' and ').toLowerCase();
                          } else {
                            firstMessage =
                              'Hi ' +
                              patientPartner.name +
                              ', I would like to chat about ' +
                              (mentorConversationTopics || []).slice(0, -1).join(', ').toLowerCase() +
                              ' and ' +
                              mentorConversationTopics[mentorConversationTopics.length - 1].toLowerCase();
                          }
                        }
                        history.push(`/member/conversations/${conversation.uuid}?firstMessage=${firstMessage}`);
                      }
                    );
                  }}
                />
              </Route>
            </Switch>
          </div>
          <div className='col-md-2'></div>
        </div>
      </div>
    </div>
  );
}
